import createReactClass from 'create-react-class';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Constants from '../constants/constants';
import { restrictionRequestStore } from '../stores/restrictionRequest';

export const RejectReasonModal = createReactClass({
    getInitialState() {
        return {
            showModal: false,
            reasonCodes: restrictionRequestStore.getRejectReasonCodes()
        };
    },

    close() {
        this.setState({ showModal: false });
    },

    reject() {
        this.props.actionCreator.submitItemToServer({
            action: Constants.restrictionActions.REJECT_REQUEST,
            printLata: this.props.printLata,
            id: this.props.requestId,
            requestToSubmit: restrictionRequestStore.restrictionFormattedForSubmission(),
            rejectReason: this.state.val
        });
        this.setState({ showModal: false });
    },

    cancel() {
        this.setState({ showModal: false });
    },

    open() {
        var st = this.getInitialState();
        st.showModal = true;
        st.val = null;
        this.setState(st);
    },

    radioOnChange(e) {
        var st = this.state;
        st.val = e.target.value;
        this.setState(st);
    },

    render: function () {
        var rejectReasons = this.props.reasonCodes.map(function (reason, i) {
            return (
                <div><input type="radio" name="rejectReason" key={i} value={reason.text}
                    onChange={this.radioOnChange} />
                    {reason.text}
                </div>
            );
        }.bind(this));

        return (
            <div>
                <Button
                    id="rejectButton"
                    bsStyle="danger"
                    disabled={this.props.disabled}
                    onClick={this.open}>
                    Reject
                </Button>
                <Modal bsSize="small" onHide={this.close} dialogClassName="rejectModal" show={this.state.showModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Reject Reason</Modal.Title>
                    </Modal.Header>

                    <div className='modal-body'>
                        <div>Select a reason for rejecting the request:</div>
                        {rejectReasons}
                    </div>
                    <div className='modal-footer'>
                        <Button id="rejectConfirmButton" disabled={!this.state.val} bsStyle='primary' onClick={this.reject}>Reject Request</Button>
                        <Button id="rejectCancelButton" onClick={this.cancel}>Cancel</Button>
                    </div>
                </Modal>
            </div>
        );
    },
});
